import Accordions from '../components/Accordions';

const nlAccordions = document.querySelectorAll('[data-accordion-group]');

if (nlAccordions.length > 0) {
    nlAccordions.forEach(el => new Accordions(el));
} else {
    new Accordions(document.body);
}
